import React from 'react'
import MainTitle from '../common/MainTitle'
import CustomHr from '../common/CustomHr'
import { H6 } from '@blueprintjs/core'
import { translate } from 'utlis/translations/i18n'

const OpenFeedback = ({ feedback, selectedName }) => {

    return (
        <div>
            <MainTitle text={< span> Feedback: <br /><br /> {feedback.feedback.question}</span>} />
            <div className="new-results new-results-feedbacks">
                {feedback.answers.map((answer, index) => {
                    if ((answer.answer !== "") && !answer.answer.includes('bla bla') && (!selectedName || answer.participantName === selectedName)) {  
                        return (
                            <div className="feed-newRes margin-bottom-small" key={index}>
                                <H6 className='new-results'>{answer?.participantName || `${translate('respondant')} ${index + 1}` } </H6>
                                <p>"{answer.answer}"</p>
                            </div>
                        )
                    } else {
                        return null
                    }
                })}
            </div>
            <CustomHr />
        </div>
    )
}

export default OpenFeedback;